import { colors } from '@updater/angular-common';
import { ITEM_DEFINITION_CODES } from '../../../constants/item-definitions';
import { ITEM_STATUSES } from '../../../constants/items';
import template from './subheader.html';
import './subheader.global.css';

const INITIAL_PROGRESS = 0.05; // Give users 5% of completion for getting here

const UNEDITABLE_CODES = [
  ITEM_DEFINITION_CODES.FORWARD_MAIL,
  ITEM_DEFINITION_CODES.UPDATE_ACCOUNT,
];

const COMPLETED_STATUSES = [
  ITEM_STATUSES.PENDING,
  ITEM_STATUSES.ALREADY_DONE,
  ITEM_STATUSES.COMPLETED,
];

const isCompleted = step => COMPLETED_STATUSES.indexOf(step.status) !== -1;
const isCounted = step => step.status !== ITEM_STATUSES.NOT_NEEDED;

class DashboardSubheaderController {
  constructor() {
    this.colors = colors;
  }

  get completedPercent() {
    const { completed, total } = this.phases.reduce(
      (result, phase) =>
        phase.steps.reduce(
          ({ completed, total }, step) => ({
            completed: completed + (isCompleted(step) ? 1 : 0),
            total: total + (isCounted(step) ? 1 : 0),
          }),
          result
        ),
      { completed: 0, total: 0 }
    );

    const percentage = (completed / total) * (1 - INITIAL_PROGRESS);
    return (isNaN(percentage) ? 0 : percentage) + INITIAL_PROGRESS;
  }

  get moveDateEditable() {
    return this.phases.reduce(
      (editable, phase) =>
        editable &&
        !phase.steps.some(
          step =>
            UNEDITABLE_CODES.indexOf(step.code) !== -1 &&
            step.itemStatuses.some(
              ({ status }) => status === ITEM_STATUSES.COMPLETED
            )
        ),
      true
    );
  }
}

export const DashboardSubheaderComponent = {
  controller: DashboardSubheaderController,
  bindings: {
    move: '<',
    phases: '<',
    moveDateChange: '&',
    phaseSelect: '&',
  },
  template,
};
